import { signOut } from 'firebase/auth';
import { auth } from '@/services/firebase';
import { authenticateNodebb, deAuthenticateNodebb } from '@/api/auth';

import { Role } from '@/utils/auth';
// eslint-disable-next-line import/no-cycle
import router from '@/router';

const defaultState = () => ({
  currentUser: {},
  role: Role.GUEST,
  tokenData: {},
  isAuthenticated: false,
  lastSignInTime: null,
});

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    reset(state) {
      Object.assign(state, defaultState());
    },
    setCurrentUser(state, user) {
      state.currentUser = user;
    },
    setUserRole(state, role) {
      state.role = role;
    },
    setIdTokenResult(state, tokenData) {
      state.tokenData = tokenData;
    },
    setAuthState(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated;
    },
    setLastSignInTime(state, GMTString) {
      state.lastSignInTime = GMTString;
    },
  },
  actions: {
    onAuthStateChanged: async ({ commit, dispatch }, user) => {
      if (user && user.email) {
        commit('setCurrentUser', user);
        commit('setLastSignInTime', user.metadata.lastSignInTime);
        const data = await user.getIdTokenResult();
        commit('setAuthState', !!user);
        commit('setUserRole', data.claims.role || Role.GUEST);
        commit('setIdTokenResult', data);

        try {
          await dispatch('user/loadUser', null, { root: true });
          await dispatch('user/subscriptionPlans/get', null, { root: true });
          commit('paidTier/setLoaded', false, { root: true });
          await dispatch('authenticateNodebb');
        } catch {
          commit('reset');
        }
      } else {
        commit('reset');
      }
    },
    signOut: async ({ dispatch, commit }) => {
      try {
        commit('auth/reset', null, { root: true });
        await signOut(auth);
        commit('user/resetUser', null, { root: true });
        await dispatch('widgets/clearLinks', null, { root: true });
        await router.push({ name: 'Homepage' });
        await dispatch('deAuthenticateNodebb');
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
      }
    },
    authenticateNodebb: async () => {
      try {
        await authenticateNodebb();
      } catch (e) {
        console.log(e);
      }
    },
    deAuthenticateNodebb: async () => {
      try {
        await deAuthenticateNodebb();
      } catch (e) {
        console.log(e);
      }
    },
  },
  getters: {
    role: state => state.role,
    email: state => state.tokenData.claims && state.tokenData.claims.email,
    isAuthenticated: state => state.isAuthenticated,
    tokenData: state => state.tokenData || {},
    lastSignInTime: state => state.lastSignInTime,
    id: state => state.currentUser.uid,
    isAdmin: state => state.role === Role.ADMIN,
  },
};
